import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    // Skip auth check if user data was passed from AuthCallback
    if (location.state?.user) {
      return;
    }

    // Wait for auth check to complete
    if (!loading) {
      if (!isAuthenticated || !user?.is_admin) {
        setShouldRedirect(true);
      }
    }
  }, [isAuthenticated, loading, user, location.state]);

  // Show loading while checking auth
  if (loading || isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-[#ECEC75] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#D4AF37] mx-auto mb-4"></div>
          <p className="text-xl font-semibold text-black">Vérification...</p>
        </div>
      </div>
    );
  }

  // Redirect if not authenticated or not admin
  if (shouldRedirect) {
    return <Navigate to="/admin/login" replace />;
  }

  // Render protected content
  return children;
};

export default ProtectedRoute;
